type QueryType = "query" | "mutation";
type RecordType = "users" | "roles";

export class FetchError extends Error {
  queryType: QueryType;
  recordType: RecordType;
  context: unknown;
  constructor(args: {
    message: string;
    queryType: QueryType;
    recordType: RecordType;
    context?: unknown;
  }) {
    super(args.message);
    this.name = "FetchError";
    this.queryType = args.queryType;
    this.recordType = args.recordType;
    this.context = args.context;
  }
}

export class ApiError extends Error {
  status: number;
  queryType: QueryType;
  recordType: RecordType;
  context: unknown;
  constructor(args: {
    message: string;
    queryType: QueryType;
    recordType: RecordType;
    status: number;
    context?: unknown;
  }) {
    super(args.message);
    this.name = "ApiError";
    this.status = args.status;
    this.queryType = args.queryType;
    this.recordType = args.recordType;
  }
}

export class NoAuthTokenError extends Error {
  context: unknown;
  constructor(args?: { context?: unknown }) {
    super("No auth token provided");
    this.name = "NoAuthTokenError";
    this.context = args?.context;
  }
}

export class IncorrectPermissionsError extends Error {
  context: unknown;
  constructor(args?: { context?: unknown }) {
    super("Incorrect permissions");
    this.name = "IncorrectPermissionsError";
    this.context = args?.context;
  }
}

export class ExpiredTokenError extends Error {
  context: unknown;
  constructor(args?: { context?: unknown }) {
    super("Access token expired");
    this.name = "ExpiredTokenError";
    this.context = args?.context;
  }
}
